import gql from "graphql-tag";
import { productSetQueryReturnFields } from "../queries/getProductSet";

export const CREATE_PRODUCT_SET = gql`mutation createProductSet($createProductSetInput: CreateProductSetInput!) {
    createProductSet(createProductSetInput: $createProductSetInput) {
        ${productSetQueryReturnFields}
    }
}`;
